(() => {
  if (window.__tpCartRecovery || typeof window.fetch !== 'function') return;
  const siteId = document.currentScript?.dataset.siteId;
  if (!siteId) return;
  window.__tpCartRecovery = true;
  const forms = { WcyHAt: 'ES', VM9DGg: 'EN' };
  const pending = new Set();
  const fetchRequest = window.fetch.bind(window);
  const pause = ms => new Promise(resolve => setTimeout(resolve, ms));
  const notify = (state, formId, requestId) => window.dispatchEvent(new CustomEvent('tp:cart-recovery', {
    detail: { state, formId, requestId }
  }));

  async function request(url, options, expectedStatus) {
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        const response = await fetchRequest(url, { ...options, signal: AbortSignal.timeout(5000) });
        if (expectedStatus ? response.status === expectedStatus : response.ok) return response;
        if (response.status !== 429 && response.status < 500) throw new Error('rejected');
      } catch (error) {
        if (error.message === 'rejected' || attempt === 2) throw error;
      }
      if (attempt === 2) throw new Error('unavailable');
      await pause(250 * (attempt + 1));
    }
  }

  function snapshot(cart, formId, requestId, requestedAt, root) {
    if (!Array.isArray(cart.items) || !cart.items.length) return null;
    const quantities = new Map();
    const items = cart.items.map(line => {
      const variantId = String(line.variant_id || line.id || '');
      const quantity = Number(line.quantity);
      if (!/^\d+$/.test(variantId) || !Number.isSafeInteger(quantity) || quantity < 1) throw new Error('invalid-cart');
      quantities.set(variantId, (quantities.get(variantId) || 0) + quantity);
      const image = line.featured_image?.url || line.image;
      const imageUrl = image ? new URL(image, location.origin) : null;
      return {
        title: String(line.product_title || line.title || '').slice(0, 1000),
        variant: line.variant_title === 'Default Title' ? '' : String(line.variant_title || '').slice(0, 500),
        variant_id: variantId,
        quantity,
        image_url: imageUrl?.protocol === 'https:' ? imageUrl.href : ''
      };
    });
    const lines = [...quantities].map(([id, quantity]) => `${id}:${quantity}`).join(',');
    const url = new URL(`cart/${lines}`, root);
    url.searchParams.set('storefront', 'true');
    const locale = window.Shopify?.locale || document.documentElement.lang;
    if (locale) url.searchParams.set('locale', locale);
    return {
      FormID: formId,
      CartURL: url.href,
      RequestedAt: requestedAt,
      RequestID: requestId,
      Items: items,
      Summary: items.map(item => `${item.quantity} × ${item.title}${item.variant ? ` — ${item.variant}` : ''}`).join(' · ').slice(0, 5000),
      Lang: forms[formId],
      ItemCount: items.reduce((total, item) => total + item.quantity, 0),
      Currency: cart.currency || '',
      TrackingSource: 'tp-arctos-cart-request-v2'
    };
  }

  window.addEventListener('klaviyoForms', async event => {
    const detail = event.detail || {};
    const formId = detail.formId || detail.formID;
    if (detail.type !== 'submit' || !Object.hasOwn(forms, formId)) return;
    if (detail.companyId && detail.companyId !== siteId) return;
    const email = String(detail.metaData?.email || detail.metaData?.$email || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
    const key = `${formId}:${email.toLowerCase()}`;
    if (pending.has(key)) return;
    pending.add(key);
    const requestId = window.crypto?.randomUUID?.() || `tp-cart-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const requestedAt = new Date().toISOString();
    try {
      const root = new URL(window.Shopify?.routes?.root || '/', location.origin);
      if (root.origin !== location.origin || !root.pathname.endsWith('/')) throw new Error('invalid-root');
      const response = await request(new URL('cart.js', root).href, {
        credentials: 'same-origin', cache: 'no-store', headers: { accept: 'application/json' }
      });
      const properties = snapshot(await response.json(), formId, requestId, requestedAt, root);
      if (!properties) {
        notify('empty', formId, requestId);
        return;
      }
      const body = JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            unique_id: requestId,
            time: requestedAt,
            properties,
            metric: { data: { type: 'metric', attributes: { name: 'TP Cart Recovery Requested' } } },
            profile: { data: { type: 'profile', attributes: {
              email,
              properties: {
                TP_CartRecoveryStatus: 'captured',
                TP_CartRecoveryForm: formId,
                TP_CartRecoveryID: requestId,
                TP_CartRecoveryRequestedAt: requestedAt,
                TP_CartRecoveryURL: properties.CartURL,
                TP_CartRecoveryItems: properties.Items,
                TP_CartRecoverySummary: properties.Summary
              }
            } } }
          }
        }
      });
      await request(`https://a.klaviyo.com/client/events?company_id=${encodeURIComponent(siteId)}`, {
        method: 'POST', credentials: 'omit',
        keepalive: new TextEncoder().encode(body).byteLength < 60000,
        headers: { accept: 'application/vnd.api+json', 'content-type': 'application/vnd.api+json', revision: '2026-10-15' },
        body
      }, 202);
      notify('accepted', formId, requestId);
    } catch {
      notify('failed', formId, requestId);
      console.warn('[TP cart request] Could not capture the requested cart.');
    } finally {
      setTimeout(() => pending.delete(key), 1500);
    }
  });
})();
